import amountFormatter from "../../utils/amountFormatter";
import deleteLogo from "../../assets/delete.svg";
import editLogo from "../../assets/edit.svg";
import { useDispatch } from "react-redux";
import { useNavigate, useMatch } from "react-router-dom";
import { editActive, deleteActive } from "../../features/transaction/transactionSlice";

const Transaction = ({ transaction }) => {
	const { name, amount, type } = transaction || {};
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const match = useMatch("/");

	const handleEdit = () => {
		dispatch(editActive(transaction));

		if (!match) {
			navigate("/", { replace: true });
		}
	};

	const handleDelete = () => {
		dispatch(deleteActive(transaction));
	};

	return (
		<div
			className={`${
				type === "income"
					? "bg-green-50 border-green-500"
					: "bg-red-50 border-red-400"
			} w-full border-2 shadow-md rounded-md py-3 px-4`}
		>
			<h3 className="sm:text-lg">{name}</h3>
			<div className="flex justify-between">
				<div className="sm:text-lg font-medium">
					<span>৳</span> <span>{amountFormatter(amount)}</span>
				</div>

				<div className="flex gap-2">
					<div
						className="bg-green-700 hover:bg-opacity-100 cursor-pointer bg-opacity-90 drop-shadow-lg rounded-full w-fit p-[8px]"
						onClick={handleEdit}
					>
						<img src={editLogo} alt="" className="w-[13px] sm:w-[15px]" />
					</div>
					<div
						className="bg-red-700 hover:bg-opacity-100 cursor-pointer bg-opacity-90 drop-shadow-lg rounded-full w-fit p-[8px]"
						onClick={handleDelete}
					>
						<img src={deleteLogo} alt="" className="w-[13px] sm:w-[15px]" />
					</div>
				</div>
			</div>
		</div>
	);
};

export default Transaction;
